module.exports = __webpack_public_path__ + "static/img/left-pic-2.80038bfd.png";